import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { PutOrderItemSigmaRequest } from '@/backend/market'
import { UpdateOrderItemEntity } from '../../domain/entities/UpdateOrderItemEntity'
import { PutOrderItemRequestType } from '../../domain/enums/PutOrderItemRequestType';

export class UpdateOrderItemModel extends UpdateOrderItemEntity {
    items: PutOrderItemSigmaRequest[] = [];
    constructor(dataDto: UpdateOrderItemEntity) {
        super()
        const result: PutOrderItemSigmaRequest[] = [];
        dataDto.newItems?.forEach((item) => {
            result.push({
                type: PutOrderItemRequestType.ADD,
                itemId: item.item?.id,
                quantity: item.quantity,
                selections: item.item?.selections
                    ?.filter((selection) => selection.id && selection.selectedSelections && selection.selectedSelections.length > 0)
                    .map((selection) => ({
                        selectionId: selection.id!,
                        selectionValues: selection.selectedSelections!.map((selectionValue) => ({
                            selectionValueId: selectionValue.id,
                            type: selectionValue.type
                        }))
                    })) ?? undefined
            })
        })
        dataDto.deletedItems?.forEach((item) => {
            result.push({
                type: PutOrderItemRequestType.REMOVE,
                orderItemId: item
            })
        })
        dataDto.updatedItems?.forEach((item) => {
            result.push({
                type: PutOrderItemRequestType.UPDATE_QUANTITY,
                orderItemId: item.id,
                quantity: item.quantity
            })
        })

        mapEntityProperties<UpdateOrderItemModel>(this, dataDto, {
            exclude: ['newItems', 'deletedItems', 'updatedItems'],
            map: { items: result }
        })
    }
}
